<template>
    <div>
        <div class="uk-grid-stack" uk-grid>
            <selected-shop-filter-row
                    v-for="property in FilterProperties"
                    v-if="hasSelected(property)"
                    :key="property.id"
                    :property="property"
                    :property-values="FilterPropertyValues[property.id]"
                    :selected="selectedPropertyValues[property.id]"
                    v-on="$listeners"
            ></selected-shop-filter-row>
        </div>
    </div>
</template>

<script>


    import SelectedShopFilterRow from "./SelectedShopFilterRow";

    export default {
        name: "SelectedShopFilter",
        components: {SelectedShopFilterRow},
        props: {
            FilterProperties: {
                type: Array,
                required: true,
            },
            FilterPropertyValues: {
                type: [Array, Object],
                required: true,
            },
            selectedPropertyValues: {
                type: [Array, Object],
                default() {
                    return {}
                }
            }
        },


        methods: {
            hasSelected(property) {
                return !!this.selectedPropertyValues[property.id];
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectedShopFilter.vue?604c0d96